/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";

type Props = {
  children: React.ReactNode;
};

export const AuthWall = withAuthenticationRequired(({ children }: Props) => (
  <>{children}</>
));
